import { create } from "zustand";

// v3.2 desktop: New visit (or Add recording) open in the workspace column
// instead of a sheet. The sidebar shows a "New visit" row while it is open.
export interface WorkspacePanelState {
  /** "new-visit" while New visit is open in the column. */
  active: "new-visit" | "add-recording" | null;
  /** Recording in progress (the sidebar row says "Recording"). */
  recording: boolean;
  /** Where Back returns (the page New visit was started from). */
  returnTo: string | null;
  set: (state: Partial<Omit<WorkspacePanelState, "set">>) => void;
}

export const useWorkspacePanelStore = create<WorkspacePanelState>()((set) => ({
  active: null,
  recording: false,
  returnTo: null,
  set: (state) => set(state),
}));
